import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
import { useReservedCreditPackages } from "@/hooks/use-reserved-credit-packages";

interface ReservedCreditsBadgeProps {
  orderId?: string;
  showDetails?: boolean;
}

export const ReservedCreditsBadge = ({ 
  orderId,
  showDetails = false 
}: ReservedCreditsBadgeProps) => {
  const { data: reservedYears = [] } = useReservedCreditPackages(orderId);

  if (reservedYears.length === 0) {
    return null;
  }

  const totalReservedCredits = reservedYears.reduce(
    (sum, year) => sum + year.totalCredits, 
    0
  );
  const totalYearsReserved = reservedYears.length;

  if (showDetails) {
    return (
      <div className="flex items-center gap-2 text-sm">
        <Badge 
          variant="outline" 
          className="bg-amber-50 text-amber-800 border-amber-300"
        >
          <Clock className="h-3 w-3 mr-1" />
          {totalYearsReserved} {totalYearsReserved === 1 ? 'year' : 'years'} reserved
        </Badge>
        <span className="text-muted-foreground">
          • {totalReservedCredits.toLocaleString()} credits
        </span>
      </div>
    );
  }

  return (
    <Badge 
      variant="outline" 
      className="bg-amber-50 text-amber-800 border-amber-300"
    >
      <Clock className="h-3 w-3 mr-1" />
      {totalReservedCredits.toLocaleString()} reserved
    </Badge>
  );
};
